import './App.css';
import { Outlet, RouterProvider } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';
import QuestionPage from './pages/questionPage/QuestionPage';
import No from './pages/noPage/No';
import Yes from './pages/yesPage/Yes';
import CdPortal from './pages/portal/countDownPortal/CdPortal';
import HomePage from './pages/homePage/HomePage';
import Valentine2026 from './pages/valentine2026/Valentine2026';
import SheSaidYes2026 from './pages/valentine2026/sheSaidYes/SheSaidYes2026';
import InviteRedirect from './pages/invite/InviteRedirect';
import { usePostHogPageview, usePostHogIdentify } from './hooks/usePostHog';

/**
 * Layout wrapper that lives inside the router context.
 * This gives us access to useLocation / useParams etc.
 * Fires PostHog pageviews on every route change and
 * identifies users who came through /invite/:name.
 */
function RootLayout() {
  usePostHogPageview();
  usePostHogIdentify();
  return <Outlet />;
}

function App() {
    const music = new Audio("/audio/style.mp3");

    const router = createBrowserRouter([
      {
        element: <RootLayout />,
        children: [
          {
            path: "/",
            element: <HomePage/>,
          },
          {
            path: "/invite/:name",
            element: <InviteRedirect/>,
          },
          {
            path: "/2026",
            element: <Valentine2026/>,
          },
          {
            path: "/2026/sheSaidYes",
            element: <SheSaidYes2026/>,
          },
          {
            path: "/archives/2025",
            element: <QuestionPage/>,
          },
          {
            path: "/archives/2025/sheSaidNo",
            element: <No/>,
          },
          {
            path: "/archives/2025/sheSaidYes",
            element: <Yes music={music}/>,
          },
          {
            path: "/archives/2025/portal",
            element: <CdPortal/>,
          },
        ],
      },
    ]);
  
    return (
      <div className="App">
        <RouterProvider router={router} />
      </div>
    );
  }
  
  export default App;
